/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import { WorkflowExternalStepDefDtoModel } from './workflow-external-step-def-dto.model';
import { WorkflowNotificationVoModel } from './workflow-notification-vo.model';
import { WorkflowStepVoModel } from './workflow-step-vo.model';

export class WorkflowConfigMetadata extends JSONable {
  workflowName: string | null = null;
  workflowDefaultDescription: string | null = null;
  availableSteps: WorkflowStepVoModel[] | null = null;
  availableNotifications: WorkflowNotificationVoModel[] | null = null;
  availableUiSteps: WorkflowExternalStepDefDtoModel[] | null = null;
}
